import React, { StrictMode } from 'react'
import ReactDOM from 'react-dom'
import SimpleIconsCollection from '@jimmyboys/liita-ui/dist/components/SimpleIconsCollection'

import { ReactComponent as BodyParts } from 'assets/images/body-parts-sprite.svg'
import { ReactComponent as AppIcons } from 'assets/images/app-icons.svg'

import Main from './controllers/Main/Main'
import * as serviceWorkerRegistration from './serviceWorkerRegistration'

import './index.sass'
import { initAmplitude } from 'hooks/useAnalytics'

initAmplitude()

ReactDOM.render(
	<StrictMode>
		<SimpleIconsCollection />
		<BodyParts />
		<AppIcons />
		<Main />
	</StrictMode>,
	document.getElementById('root')
)

const onSWUpdate = (registration) => {
	//eslint-disable-next-line
	if (registration.waiting) {
		registration.waiting.postMessage({ type: 'SKIP_WAITING' })
		setTimeout(() => {
			window.location.reload()
		}, 100)
	}
}

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorkerRegistration.register({ onUpdate: onSWUpdate })
